import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(phone: string, country: PhoneCountry): string {
    let purePhone = phone.replace(new RegExp('[ +()]', 'g'), '');
    if (country === 'bg') {
      return `+${purePhone.slice(0, 3)} ${purePhone.slice(
        3,
        6
      )} ${purePhone.slice(6, 9)} ${purePhone.slice(9)}`;
    }
    return phone;
  }
}

export type PhoneCountry = 'bg';
